<div class="flex flex-col mb-4 relative">
  @if(label){
  <label [for]="label" class="mb-1 font-medium text-gray-800">{{ label }}</label>
  }

  <div class="relative group">
    <input
      [id]="label"
      [type]="showPassword ? 'text' : 'password'"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      [ngClass]="{
        'border-red-500 animate-shake': error,
        'border-green-500': !error && value,
        'border-gray-300': !error && !value
      }"
      class="w-full px-4 py-2 rounded-lg border outline-none transition-all duration-300 focus:border-blue-500 pr-10"
    />

    <button
      type="button"
      (click)="togglePassword()"
      class="absolute right-3 top-[21.5px] -translate-y-1/2 text-gray-500 hover:text-gray-700"
    >
      @if(!showPassword){
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        />
      </svg>
      }
      
      @if(showPassword){
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a10.05 10.05 0 011.472-2.626M6.88 6.88A9.965 9.965 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.967 9.967 0 01-1.177 2.362M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3l18 18" />
      </svg>
      }
    </button>

    @if(!error && value){
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="absolute right-9 top-[21.5px] -translate-y-1/2 h-4 w-4 text-green-500 transition-all duration-300"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
    </svg>
    } @if(error){
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="absolute right-9 top-[21.5px] -translate-y-1/2 h-4 w-4 text-red-500 transition-all duration-300 animate-shake"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>

    <small class="text-red-500 text-sm mt-1 block animate-fadeIn">{{ error }}</small>
    }
  </div>
</div>
